// extracted by mini-css-extract-plugin
export default {"title":"Title_title__ugKfF","required":"Title_required__WzPwN"};